import { isPublicPagePath } from '@/components/auth/utils/oauthState';
import { CAMPAIGN_SESSION_STORAGE_KEY } from '@/constants';
import type { DecoratedProfile } from '@/contexts';
import type { CollectionBase } from '@/features/events/types';
import {
  type Options,
  getSigninUrl,
} from '@/features/interactions/addToGoogle/auth.lib';
import { getLocalTimeZone } from '@/utils/dates';

export const getAuthUrl = (
  currentUser: DecoratedProfile | undefined,
  options: Options,
  base?: CollectionBase | undefined,
  queryParams: Record<string, string> = {}
): string => {
  const redirectParams: Record<string, string> = {
    ...queryParams,
  };
  const state: Record<string, string | boolean | number> = {
    app: 'magic',
    timeZone: getLocalTimeZone(),
  };

  if (base?.chat?.id && base.chat.isSaved) {
    redirectParams.c = base.chat.id;
  } else if (base?.job?.id) {
    redirectParams.e = base.job.id;
  }

  const campaign = sessionStorage.getItem(CAMPAIGN_SESSION_STORAGE_KEY);
  if (campaign) {
    state.campaign = campaign;
  }

  // set, not append: the magic page already carries its own ?e= (or ?c=), so
  // appending would leave two, and URLSearchParams.get returns the *first* —
  // restoring whichever id was in the URL rather than the one we just resolved.
  const query = new URLSearchParams(location.search);
  Object.entries(redirectParams).forEach(([key, value]) => {
    query.set(key, value);
  });
  // `code` is the *result* of the previous attempt, stamped on the URL by the
  // callback. Carrying it into this attempt's redirect would land a successful
  // connect on ?code=PERMISSION_NOT_GRANTED; the callback stamps a fresh one.
  query.delete('code');

  const search = query.size > 0 ? `?${query.toString()}` : '';
  const path = window.location.pathname;

  if (isPublicPagePath(path)) {
    state.register = false;
  }

  const redirectUrl = `${path}${search}`;
  return getSigninUrl(currentUser, redirectUrl, state, options);
};
